export var cibGitter = ["32 32", "<path d='M8.15 20.156h-3.15v-20.156h3.15zM14.431 4.756h-3.15v27.244h3.15zM20.719 4.756h-3.15v27.244h3.15zM27 4.75h-3.15v15.438h3.15z'/>"];
